import { render, staticRenderFns } from "./PartnerMail.vue?vue&type=template&id=5f3cdfcd&"
import script from "./PartnerMail.vue?vue&type=script&lang=js&"
export * from "./PartnerMail.vue?vue&type=script&lang=js&"
import style0 from "./PartnerMail.vue?vue&type=style&index=0&id=5f3cdfcd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports